import { render, staticRenderFns } from "./BrickSettingsContentItem.vue?vue&type=template&id=96dac704&scoped=true&"
import script from "./BrickSettingsContentItem.vue?vue&type=script&lang=js&"
export * from "./BrickSettingsContentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dac704",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96dac704')) {
      api.createRecord('96dac704', component.options)
    } else {
      api.reload('96dac704', component.options)
    }
    module.hot.accept("./BrickSettingsContentItem.vue?vue&type=template&id=96dac704&scoped=true&", function () {
      api.rerender('96dac704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/BrickSettings/BrickSettingsContentItem.vue"
export default component.exports